import { Fragment, isValidElement } from 'react';

/**
 * Recurses through Fragments (as returned by conditional switch-case menu
 * builders) to detect whether any menu item actually survived its
 * conditions, so callers can hide the menu trigger when nothing would show.
 * @param {*} node - a React node or array of nodes
 * @returns {boolean} true if at least one non-Fragment element is present
 */
export const hasRenderableContent = (node) => {
    if (!node) return false;
    if (Array.isArray(node)) return node.some(hasRenderableContent);
    if (!isValidElement(node)) return false;
    if (node.type === Fragment)
        return hasRenderableContent(node.props.children);
    return true;
};
